import moment from 'moment';
import $ from 'jquery'
import { isLocalhostHostname } from './js/models/helper/LocalhostHelper';

window.trebbleBuildInfo = {
    ...__TREBBLE_BUILD_INFO__,
    hash: typeof __webpack_hash__ !== 'undefined' ? __webpack_hash__ : ''
};
window.trebbleBuildHash = window.trebbleBuildInfo.hash;
// Keep the bundle hash separate from the deploy identifier so analytics can
// change on every deploy without invalidating all cached JS assets.
window.trebbleDeployVersion = window.trebbleBuildInfo.deployVersion || window.trebbleBuildHash;
window.trebbleAppVersion = window.trebbleBuildHash || window.trebbleDeployVersion;

function getVersionedServiceWorkerUrl() {
    return window.trebbleAppVersion
        ? 'service-worker.js?appVersion=' + encodeURIComponent(window.trebbleAppVersion)
        : 'service-worker.js';
}

const locationHasEmbeddedCredentials = function(locationValue){
    if(!locationValue){
        return false;
    }
    if(locationValue.username || locationValue.password){
        return true;
    }
    const href = typeof locationValue === "string" ? locationValue : locationValue.href;
    if(!href){
        return false;
    }
    try{
        const parsedLocation = new URL(href);
        return !!(parsedLocation.username || parsedLocation.password);
    }catch(error){
        return false;
    }
};

window.trebbleProduction = process.env.NODE_ENV === "production"?true:false;
window.log = !window.trebbleProduction? console.log.bind(console) : function () {};
/*window.trebble = {
    models : {},
    views : {},
    helper : {},
    collections : {},
    referrer : null,
    popupLoginPageHash :"doLoginOnly", 
    unconsumedNotificationEvent : null,
    allowAutoLoginAsGuest: false,
    appRunningInQuickStartMode: false, //If this flag is true, the app will not load songs in order to speed the app start.This is useful for case where thea app is loaded from another app to perform an activity
    routerReady : false,
    trebbleRouter : null,
    showRoundCapsulePlayButton: true,
    supportPushState: true,
    globalHelpers : {},
    capsuleReplyAllow : true,
    allowProcessedAudioToPlay : false,
    supporteLanguages :["en", "fr"],
    defaultValues : {
        commentBoxHeigth : 61,
        clipboardCopyAvailable : true
    },
    config :{
        disableZoomInCoverArtInMobileApp : true,
        secondsOfPLayingRequiredForScrobble: 5,
        scrobbleListeningHistoryToDb : true,
        allowScrobblingOnDataPlan: true,
        showIdifiedArtistName : true,
        showIdifiedSongTitle : true,
        showIdifiedAlbumTitle : true,
        useSavedJQMHistory : false,
        idifiedSongInMyLibraryThatArePlayingOnDataPlan : true,
        idifiedSongInMyLibraryThatArePlayingOnWifi : true,
        prefetchNextSongUrl : true,
        prefetchNextSongUrlExpirationTimeInMilli : 5 * 60 *1000,//5minutes
        numberOfSecondsLeftOnSongForPrefetchNextSong : 30,
        numberOfSecondsElapsedForPrefetchNextSong : 10,
        iosAudioQuirkExcetuded : false,
        showSongGradePopupAfterSongAddedToTrebble : true,
        doNotShowMusicInSearchPage  : false,
        version : "0.6.0",
    }
    }

*/

var initApp = function(){
 
window.trebble = {
models : {},
views : {},
helper : {},
collections : {},
referrer : null,
popupLoginPageHash :"doLoginOnly", 
unconsumedNotificationEvent : null,
allowAutoLoginAsGuest: false,
accountSignupHasOccuredInSession: false,
signupSuccessRedirectUrl: null,
entryPointAllowsAnonymousView: false,
entryPointRequiresAuthentication: false,
appRunningInQuickStartMode: false, //If this flag is true, the app will not load songs in order to speed the app start.This is useful for case where thea app is loaded from another app to perform an activity
routerReady : false,
trebbleRouter : null,
showRoundCapsulePlayButton: true,
supportPushState: !isLocalhostHostname(window.location.hostname) && !locationHasEmbeddedCredentials(window.location),
globalHelpers : {},
capsuleReplyAllow : true,
allowProcessedAudioToPlay : false,
supporteLanguages :["en", "fr"],
defaultValues : {
    commentBoxHeigth : 61,
    clipboardCopyAvailable : true
},
config :{
    disableZoomInCoverArtInMobileApp : true,
    secondsOfPLayingRequiredForScrobble: 5,
    scrobbleListeningHistoryToDb : true,
    allowScrobblingOnDataPlan: true,
    showIdifiedArtistName : true,
    showIdifiedSongTitle : true,
    showIdifiedAlbumTitle : true,
    useSavedJQMHistory : false,
    idifiedSongInMyLibraryThatArePlayingOnDataPlan : true,
    idifiedSongInMyLibraryThatArePlayingOnWifi : true,
    prefetchNextSongUrl : true,
    prefetchNextSongUrlExpirationTimeInMilli : 5 * 60 *1000,//5minutes
    numberOfSecondsLeftOnSongForPrefetchNextSong : 30,
    numberOfSecondsElapsedForPrefetchNextSong : 10,
    iosAudioQuirkExcetuded : false,
    showSongGradePopupAfterSongAddedToTrebble : true,
    doNotShowMusicInSearchPage  : false,
    version : "0.6.0",
}
}

function setTrebblePropsThatSetBeforeInit(){
if(window._trebblePropsBeforeInit){
    for(var propKey in window._trebblePropsBeforeInit){
        window.trebble[propKey] = window._trebblePropsBeforeInit[propKey];
    }
}
}
window.RAYGUN_IOS_API_KEY ="4A0zBKEHcPfh0GuJSpBIkQ";
window.SMART_LOOK_API_KEY = "a2fac3e89a31da292734f35fdc386c5d215342a2";

setTrebblePropsThatSetBeforeInit();

if(location.protocol == 'https:' || location.protocol == 'trebble-app:'){
window.trebble.usedProtocolPrefix = "https://";
}else{
window.trebble.usedProtocolPrefix = "http://";
}

window.getDocumentClienHeight = function(){
var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream; 
if(document.documentElement){
    return document.documentElement.clientHeight;
}else{
    return (iOS) ? screen.height : window.innerHeight;
}
}

window.getDocumentClienWidth = function(){
var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream; 
if(document.documentElement){
    return document.documentElement.clientWidth;
}else{
    return (iOS) ? screen.width : window.innerWidth;
}
}

window.isInMobileAppContext = function(){
return window.waitForCordovaToLoad;
}

window.getAppContext = function(){
var context = window.isEmbeddedInIframe? "Embedded": "LiveWebsite";
if(window.waitForCordovaToLoad){
    if(window.isIOSMobileDevice){
        context = "iOSApp";
    }else{
        context = "androidApp";
    }
}
if (isLocalhostHostname(location.hostname)){
    context = "Development";
}
return context;
}

window.isWebAppInProduction = function(){
return !isLocalhostHostname(location.hostname);
}


window.trackAppContext = function(){
if(window.trebbleAnalyticsHelper && window.trebbleAnalyticsHelper.trebbleHelperSetAppContext){
    window.trebbleAnalyticsHelper.trebbleHelperSetAppContext(window.getAppContext());
}
}
window.isSafariBrowser =  /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
window.isIOSMobileDevice = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
window.isMacOs = navigator.platform.indexOf('Mac') > -1;

window.getAppEnvironment = function(){
if(window.waitForCordovaToLoad){
    if(window.isIOSMobileDevice){
        return "ios";
    }else{
        return "android";
    }
}
return "web";
}




// ServiceWorker is a progressive technology. Ignore unsupported browsers
if ('serviceWorker' in navigator) {
var isLocalDevelopmentHost = location.hostname === "localhost" || location.hostname === "127.0.0.1";
var isDesktopAppOrigin = location.protocol === "trebble-app:";
if(isLocalDevelopmentHost || isDesktopAppOrigin){
    window.log('CLIENT: service worker disabled for this origin. Clearing existing registrations.');
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
        registrations.forEach(function(registration) {
            registration.unregister();
        });
    }).catch(function(error) {
        window.log('CLIENT: service worker cleanup failure.' + error);
    });
    if(window.caches && window.caches.keys){
        window.caches.keys().then(function(cacheNames) {
            cacheNames.forEach(function(cacheName) {
                window.caches.delete(cacheName);
            });
        }).catch(function(error) {
            window.log('CLIENT: cache cleanup failure.' + error);
        });
    }
}else{
    window.log('CLIENT: service worker registration in progress.');
    navigator.serviceWorker.register(getVersionedServiceWorkerUrl()).then(function() {
        window.log('CLIENT: service worker registration complete.');
    }, function(error) {
        window.log('CLIENT: service worker registration failure.'+error);
    });
}
} else {
window.log('CLIENT: service worker is not supported.');
}

if(window.trebbleAppVersion && window.Raygun && !window.Rollbar){
window.Raygun.init('5XpMH3UvlvQ7xDRHr6RrMw==').attach();
window.Raygun.saveIfOffline(true);

window.Raygun.setVersion(window.trebbleAppVersion);
}



function updateOfflineIndicator() {
var indicatorId =  "nointernetconnectionindicator";
var noConnectionIndicatorEl = document.getElementById(indicatorId);
if(navigator.onLine){
    
    if(noConnectionIndicatorEl){
        noConnectionIndicatorEl.parentNode.removeChild(noConnectionIndicatorEl);
    }
}else{
    if(!noConnectionIndicatorEl){
        noConnectionIndicatorEl = document.createElement("DIV");
        noConnectionIndicatorEl.id = indicatorId;
        noConnectionIndicatorEl.innerHTML  = "No Internet Connection";
        if(document.body.childNodes.length > 0){
            document.body.insertBefore(noConnectionIndicatorEl, document.body.childNodes[0]);
        }else{
            document.append(noConnectionIndicatorEl);
        }
    }
}

}



window.isLocalStorageSupported = function (storage) {
try {
    var key = "__some_random_key_you_are_not_going_to_use__";
    storage.setItem(key, key);
    storage.removeItem(key);
    return true;
} catch (e) {
    return false;
}
}

// Update the online status icon based on connectivity
window.addEventListener('online',  updateOfflineIndicator);
window.addEventListener('offline', updateOfflineIndicator);
updateOfflineIndicator();

window.getNavigatorLanguage = function(){
if (navigator.languages && navigator.languages.length) {
    return navigator.languages[0];
} else {
    return navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en';
}
}

window.getAppUsedLanguage =function(){
var navigatorLanguage = window.getNavigatorLanguage();
var genericNavigatorLanguage = navigatorLanguage? navigatorLanguage.split("-")[0]: null;
var isGenericNavigatorLanguage = window.trebble.supporteLanguages.indexOf(genericNavigatorLanguage) != -1;
return isGenericNavigatorLanguage? genericNavigatorLanguage : "en";
}



moment.locale(window.getAppUsedLanguage());


window.mobilecheck = function() {
if(window.waitForCordovaToLoad){
    return true;
}
var check = false;
(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
return check;
}

window.mobileAndTabletcheck = function() {
var check = false;
(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
return check;
}

window.alertErrorMessage = function(error, subMessage, callback, buttonLabel, enableHtml){
if(window.navigator && navigator.trebbleNotification && navigator.trebbleNotification.alert){
    if(enableHtml && subMessage){
        // When HTML is enabled, pass subMessage as html parameter (3rd position) instead of text parameter (5th position)
        navigator.trebbleNotification.alert(error && error.message?error.message: error, callback, subMessage, "error", null, buttonLabel);	
    }else{
        // Default behavior: pass subMessage as text parameter (5th position)
        navigator.trebbleNotification.alert(error && error.message?error.message: error, callback, false, "error", subMessage, buttonLabel);	
    }
}else{
    window.alert(error && error.message ? error.message : String(error));
}
try{
    const expectedErrorInfo = window.getExpectedErrorInfo ?
        window.getExpectedErrorInfo(error) :
        null;
    const shouldSkipRollbarForExpectedError = expectedErrorInfo ?
        expectedErrorInfo.isExpected :
        !!(error && typeof error === "object" && (
            error.name === "ExpectedError" ||
            error.isNetworkError === true ||
            error.expectedErrorCategory
        ));
    if(shouldSkipRollbarForExpectedError){
        if(window.trackExpectedErrorSkippedRollbar){
            window.trackExpectedErrorSkippedRollbar(error, "alertErrorMessage");
        }
        return;
    }
    if(window.Rollbar){
        window.Rollbar.error(error?error : new Error("no error message provided"));
    }
}catch(error){
    console.error("Failed sending error to Rollbar" + error);
}
}

/**
 * Display error message to user without error tracking.
 * Use this for expected validation errors, not system bugs.
 * 
 * Examples of when to use:
 * - User input validation failures ("Username already exists")
 * - Form validation errors ("Please fill required fields")
 * - Business rule violations ("Cannot delete last item")
 * - User-initiated cancellations ("Operation cancelled")
 * 
 * Examples of when NOT to use (use alertErrorMessage instead):
 * - Network failures
 * - Unexpected system errors
 * - API failures
 * - Runtime exceptions
 * - Any error that indicates a bug or system issue
 */
window.alertUserErrorMessage = function(error, subMessage, callback, buttonLabel) {
if (window.navigator && navigator.trebbleNotification && navigator.trebbleNotification.alert) {
    navigator.trebbleNotification.alert(error && error.message ? error.message : error, callback, false, "error", subMessage, buttonLabel);
} else {
    window.alert(error);
}
};

/**
 * Display warning message to user without error tracking.
 * Use this for user-facing warnings that don't require error tracking.
 * 
 * @param {string} message - The warning message
 * @param {string} subMessage - Optional subtitle message
 * @param {Function} callback - Optional callback when user dismisses alert
 * @param {string} buttonLabel - Optional custom button label
 */
window.alertUserWarningMessage = function(message, subMessage, callback, buttonLabel) {
if (window.navigator && navigator.trebbleNotification && navigator.trebbleNotification.alert) {
    navigator.trebbleNotification.alert(message, callback, false, "warning", subMessage, buttonLabel);
} else {
    window.alert(message);
    if(typeof callback === "function"){
        callback();
    }
}
};

window.alertWarningMessage = function(message, subMessage, callback, buttonLabel){
if(window.navigator && navigator.trebbleNotification && navigator.trebbleNotification.alert){
    navigator.trebbleNotification.alert(message, callback, false, "warning", subMessage, buttonLabel);	
}else{
    window.alert(message);
}
}

window.alertSuccessMessage = function(message, subMessage, callback, buttonLabel){
if(window.navigator && navigator.trebbleNotification && navigator.trebbleNotification.alert){
    navigator.trebbleNotification.alert(message, callback, false, "success",subMessage, buttonLabel);
}else{
    window.alert(message);
}
}

/**
 * Display confirmation dialog with defensive null checks.
 * Prevents crashes when navigator.trebbleNotification is unavailable.
 * Falls back to native confirm dialog.
 *
 * @param {string} message - The confirmation message
 * @param {Function} callback - Callback with button index (1=cancel, 2=confirm)
 * @param {string} title - Dialog title
 * @param {Array<string>} buttonLabels - [cancelLabel, confirmLabel]
 * @param {boolean} html - Enable HTML in message
 * @param {string} type - Alert type (optional)
 * @param {string} text - Subtitle text
 * @param {boolean} showLoaderOnConfirm - Show loading state
 * @param {string} customImageUrl - Custom image URL
 * @param {string} customImageSize - Custom image size
 */
window.showConfirmDialog = function(message, callback, title, buttonLabels, html, type, text, showLoaderOnConfirm, customImageUrl, customImageSize) {
    if(window.navigator && navigator.trebbleNotification && navigator.trebbleNotification.confirm){
        navigator.trebbleNotification.confirm(message, callback, title, buttonLabels, html, type, text, showLoaderOnConfirm, customImageUrl, customImageSize);
    }else{
        // Fallback to native confirm when polyfill unavailable
        var result = window.confirm(message);
        if(callback){
            callback(result ? 2 : 1); // 2 = confirmed, 1 = cancelled
        }
    }
};

window.getTopPositionForPopupWindow = function(h) {
// Fixes dual-screen position                         Most browsers      Firefox
var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
return ((height / 2) - (h / 2)) + dualScreenTop;
}

window.getLeftPositionForPopupWindow = function(w) {
// Fixes dual-screen position                         Most browsers      Firefox
var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
return ((width / 2) - (w / 2)) + dualScreenLeft;

}

window.getAppBaseUrl = function(){
if(window.location.pathname.indexOf(".html") != -1){
    return window.location.pathname.substr(0,window.location.pathname.indexOf(".html")) + ".html" +"/";
}else{
    return "/";
}
}	

window.getPageFragmentUrl = function(pageId){
if(window.trebble.supportPushState){
    return window.getAppBaseUrl() + ""+ pageId;
}else{
    return "#"+ pageId;
}
}

window.getCurrentUrlFragment = function(){
if(window.trebble.supportPushState){
    return location.pathname;
}else{
    return location.hash;
}
}

window.getPathNameWithoutHtmlPage = function(){
if(window.location.pathname.indexOf(".html") != -1){
    var pageHtml =  window.location.pathname.substr(0,window.location.pathname.indexOf(".html")) + ".html";
    return window.location.pathname.substr(pageHtml.length);
}else{
    return window.location.pathname;
}
}

window.getI18n = function(templateI18n, key, params){
    let message = templateI18n[key];
    
    // If no message found, return undefined
    if (!message) {
        return undefined;
    }
    
    // If params are provided, perform interpolation
    if (params && typeof params === 'object') {
        // Replace all placeholders in the format {paramName}
        message = message.replace(/\{(\w+)\}/g, function(match, paramName) {
            return params[paramName] !== undefined ? params[paramName] : match;
        });
    }
    
    return message;
}

window.getBaseUrlWithoutEndSlash = function(){
var baseUrlWithSlash = location.origin + window.getAppBaseUrl();
var baseUrlWithoutSlash = baseUrlWithSlash.charAt(baseUrlWithSlash.length -1) == "/"? baseUrlWithSlash.substr(0,baseUrlWithSlash.length -1 ):baseUrlWithSlash;
return baseUrlWithoutSlash;
}

window.getResourceURLAccordingToLocationProtocol = function(url){
return (window.location.protocol == "http:"||window.location.protocol == "https:")?url: "."+url;
}

window.htmlDecode = function(input) {
var doc = new DOMParser().parseFromString(input, "text/html");
return doc.documentElement.textContent;
}

window.showNativeListPickerForSelect = function(event, selectEl, title, doneButtonLabel, cancelButtonLabel){
if(selectEl && selectEl.children && selectEl.children.length > 0){
    var items = [];
    var selectedValue = null;
    for(var i =0; i < selectEl.children.length; i++){
        var optionEl = selectEl.children[i];
        items.push({"text": window.htmlDecode(optionEl.innerHTML), "value": optionEl.value});
        if(optionEl.selected){
            selectedValue = optionEl.value;
        }
    }
    if(items.length >0 && window.waitForCordovaToLoad && window.isIOSMobileDevice && window.plugins && window.plugins.listpicker){
        if(event){
            event.preventDefault();
        }
        var config = {"title":title, "items": items,"selectedValue":selectedValue,"doneButtonLabel":doneButtonLabel,"cancelButtonLabel": cancelButtonLabel};
        
        window.plugins.listpicker.showPicker(config, (function(value){
            if(value){
                var selectEl$el = $(this.selectEl);
                selectEl$el.val(value);
                selectEl$el.selectmenu("refresh", true);
                selectEl$el.trigger("change")
            }
        }).bind({"selectEl":selectEl}),function(){

        })

    }
}

}

if(window.waitForCordovaToLoad){
window.trebble.isMobileContext = true;
window.trebble.allowEasySignupForListenersAtLogin = true;
window.trebble.doNotShowMusicInSearchPage = true;
window.trebble.useMediaRecorderForAudioRecording  = true;
window.trebble.presetAccessCode = "7B2-DXWC-EMP1";
//window.trebble.presetAccessCode = "SAMS-UNG-KKGE";
window.trebble.userNeedToRequestAnInviteToSetupTrebble = false;
window.trebble.allowCreatingCapsuleWithBackgroundMusic = false;
window.enableFeatureDisplayBeforeLogin = false;
window.trebble.onlyAllowUserToSetupTrebbleFromScratch = true;
window.trebble.useNativeRecording = true;//!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
window.trebble.useNativeLoading = false;
}else{
window.trebble.presetAccessCode = "WEBB-58D2-V8V";
window.trebble.useMediaRecorderForAudioRecording = true;
//This following code should be commented 
//window.enableFeatureDisplayBeforeLogin = true;
//window.trebble.presetAccessCode = "7B2-DXWC-EMP1";
}

window.addEventListener("dragover",function(e){
e = e || event;
e.preventDefault();
},false);
window.addEventListener("drop",function(e){
e = e || event;
e.preventDefault();
},false);
// window.usingDefaultCoverArt = true;

window.trebble.models = {
helper : {},
}

window.isIOS = function() {
    //for Cordova
    var userAgent = window.navigator.userAgent.toLowerCase();
    var result = /iphone|ipad|ipod/.test( userAgent );


    return result;
}

window._loadScript  = function(scriptToLoad) {
return new Promise((resolve, reject) => {
  const script = document.createElement('script');
  script.src = scriptToLoad;
  script.async = true;

  script.onload = () => {
    resolve();
  };

  script.onerror = (err) => {
    reject(err);
  };

  document.head.appendChild(script);
});
};



window.ID = function() {
// Math.random should be unique because of its seeding algorithm.
// Convert it to base 36 (numbers + letters), and grab the first 9
// characters
// after the decimal.
return '_' + Math.random().toString(36).substr(2, 9);
};

window.addEventListener("cordovacallbackerror", function (event) {
if(event.error){
    window.sendErrorToRaygun(event.error);
}
});

window.addEventListener('beforeinstallprompt', function(event)  {
// Prevent Chrome <= 67 from automatically showing the prompt
event.preventDefault();
// Stash the event so it can be triggered later.
window.installPromptEvent = event;
var installPWABtnEl = document.getElementById("installPWABtn");
if(installPWABtnEl){
    installPWABtnEl.style.display = "block";
}

});


};
initApp();
